import { useQuery } from "@tanstack/react-query";

import { getProject, fetchTicketComments } from "../../../services/projects";

export function useTicketViewData(ticketId: string | null) {
  const ticket = useQuery({
    queryKey: ["ticket-view", ticketId],
    queryFn: () => getProject(ticketId!),
    enabled: !!ticketId,
    staleTime: 60_000,
  });

  const comments = useQuery({
    queryKey: ["ticket-view-comments", ticketId],
    queryFn: () => fetchTicketComments({ ticketId: ticketId!, query: "" }),
    enabled: !!ticketId,
    staleTime: 60_000,
  });

  return {
    ticket: ticket.data,
    comments: comments.data,
    isLoading: ticket.isLoading || comments.isLoading,
  };
}
